import { render, staticRenderFns } from "./FinanceModuleTabs.vue?vue&type=template&id=1d7bd196&scoped=true"
import script from "./FinanceModuleTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceModuleTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FinanceModuleTabs.vue?vue&type=style&index=0&id=1d7bd196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bd196",
  null
  
)

export default component.exports